import { WallSconceFlatIcon } from './WallSconceFlatIcon';

/**
 * author: GreenTurtwig
 * id 4F0EF72A-F2A8-4BFA-9E6F-279E159FC888
 * name wall-sconce-flat
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wall-sconce-flat.svg
 * tags
 * - Home Automation 
 */
export const CeilingLightFlatIcon = WallSconceFlatIcon;
export default CeilingLightFlatIcon